// src/context/SidebarContext.tsx
import React, { createContext, useContext, useState } from 'react';

interface SidebarContextProps {
    customVerticalSidebar: boolean;
    setcustomVerticleSidebar: (value: boolean) => void;

}

const SidebarContext = createContext<SidebarContextProps | undefined>(undefined);

export const CustomVerticalMenuContext: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [customVerticalSidebar, setcustomVerticleSidebar] = useState(false);
   

    return (
        <SidebarContext.Provider value={{ customVerticalSidebar, setcustomVerticleSidebar,     }}>
            {children}
        </SidebarContext.Provider>
    );
};

// Custom Hook for easy access
export const useSidebarMenu = () => {
    const context = useContext(SidebarContext);
    if (!context) {
        throw new Error('useSidebarMenu must be used within a SidebarProvider');
    }
    return context;
};
